
export default {
    name: 'DashboardBusinessJobs',
    props: {
        /**
         * Table title
         */
        title: {
            type: String,
            required: true,
        },
        /**
         * Array of Objects containing businesses potential jobs
         */
        jobs: {
            type: Array,
            required: true,
        },
        /**
         * User object
         */
        user: {
            type: Object,
            required: true,
        },
        /**
         * Parent loading status
         */
        loading: {
            type: Boolean,
            required: true,
        },
        /**
         * View all route, Nuxt Object
         */
        viewAllRoute: {
            type: Object,
            default() {
                return null;
            },
        },
        /**
         * Determines which type of jobs table this is (nearby, bookings or quotes)
         */
        type: {
            type: String,
            default: '',
        },
        /**
         * Text for the SiteEmpty component if jobs Array is empty
         */
        emptyText: {
            type: String,
            required: true,
        },
        /**
         * Total number of results
         */
        totalResults: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        returnViewAll() {
            switch (this.type) {
                default:
                case 'nearby':
                    return this.$t('jobs.view_all.jobs_nearby', { num: this.totalResults });
                case 'bookings':
                    return this.$t('jobs.view_all.bookings', { num: this.totalResults });
                case 'quotes':
                    return this.$t('jobs.view_all.quotes', { num: this.totalResults });
            }
        },
    },
};
